import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ThemeService } from '../../theme.services';
import { PagesServices } from '../../../pages/pages.services';
import { Router } from "@angular/router";

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private unsubscribe = new Subject();
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private _themeService: ThemeService,
              private _pagesServices: PagesServices,
              private _router: Router) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    var data = this._themeService.GetUserInfo();

    this.user ={
      name: data.name,
      picture: 'data:image/jpeg;base64,'+data.photo
    }

    if(data.photo == null){
      this.user.picture = 'assets/images/no-photo.png';
    }

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

      this.menuService.onItemClick()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((event) => {

      if (event.item.title === 'Log out') {

   
          var data = this._themeService.GetUserInfo();
          var logoutProcess =  localStorage.getItem("logout");

          if(data != null && logoutProcess == null){
    
            localStorage.setItem("logout","true");
            
            setTimeout(() => {
              localStorage.removeItem("logout");
            }, 3000);

            this._pagesServices.DisconnectWebSocket();
            this._themeService.LogOut().subscribe(res=>{
                
                localStorage.removeItem("logout");
                this._router.navigate(["/login"]).then(()=>window.location.reload());
            })
          }
          this._router.navigate(["/login"]).then(()=>window.location.reload());
        }else if(event.item.title === 'Profile'){

          this._router.navigate(['/pages/profile']);
       }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
